import { render } from "./EditValidationTask.vue?vue&type=template&id=5240f566&ts=true"
import script from "./EditValidationTask.vue?vue&type=script&lang=ts"
export * from "./EditValidationTask.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__